import React, { useEffect, useState } from "react";
import Card from "components/card";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  postRaiseComplaint,
  postUploadImages,
} from "../../../redux/action/index";
import Slider from "react-slick"; // A simple slider package
import { RxCrossCircled } from "react-icons/rx";
import toast from "react-hot-toast";
import { FiUpload } from "react-icons/fi";
import { getCookie } from "utils/cookie";
import { BiCheckCircle } from "react-icons/bi";
import { ConvertDateToEpoch } from "utils/functions";
import { sanitizeInputManually } from "../../../utils/sanitizeHtml";

const RaiseComplaint = () => {
  const [subject, setSubject] = useState("");
  const [date, setDate] = useState("");
  const [location, setLocation] = useState("");
  const [unit, setUnit] = useState("");
  const [buildingNo, setBuildingNo] = useState("");
  const [natureOfComplaint, setNatureOfComplaint] = useState("");
  const [description, setDescription] = useState("");
  const [complaintType, setComplaintType] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [images, setImages] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);

  const [subjectError, setSubjectError] = useState("");
  const [dateError, setDateError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [unitError, setUnitError] = useState("");
  const [buildingNoError, setBuildingNoError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [complaintTypeError, setComplaintTypeError] = useState("");
  const [natureOfComplaintError, setNatureOfComplaintError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [loading, setLoading] = useState(false);
  const [imageUploaded, setImageUploaded] = useState(false);

  const [comment, setComment] = useState("");
  const [commentError, setCommentError] = useState("");
  const [jobNumber, setjobNumber] = useState("");
  const [jobNumberError, setJobNumberError] = useState("");
  const [complaintStatus, setComplaintStatus] = useState("");
  const [complaintStatusError, setComplaintStatusError] = useState("");
  const [expectedDate, setExpectedDate] = useState("");
  const [expectedDateError, setExpectedDateError] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [submitting, setSubmitting] = useState(false); // Add state for submission status

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    // Get current date in YYYY-MM-DD format and set it as default value
    const currentDate = new Date().toISOString().split("T")[0];
    setDate(currentDate);
    setPhoneNumber(getCookie("phone"));
    setName(getCookie("user_name"));
  }, []);

  const validateComplaintStatus = (complaintStatus) => {
    if (!complaintStatus.trim()) {
      setComplaintStatusError("Complaint Status is required.");
      return false;
    }
    setComplaintStatusError("");
    return true;
  };
  const validateComment = (comment) => {
    if (!comment.trim()) {
      setCommentError("Comment is required.");
      return false;
    }
    setCommentError("");
    return true;
  };
  const validateExpectedDate = (expectedDate) => {
    if (!expectedDate.trim()) {
      setExpectedDateError("Date is required.");
      return false;
    }
    setExpectedDateError("");
    return true;
  };
  const validateJobNumber = (date) => {
    if (!date.trim()) {
      setJobNumberError("Job number is required.");
      return false;
    }
    setJobNumberError("");
    return true;
  };

  // const validateSubject = (subject) => {
  //   if (!subject.trim()) {
  //     setSubjectError("Subject is required.");
  //     return false;
  //   }
  //   setSubjectError("");
  //   return true;
  // };

  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\d{10}$/; // Only 10 digits allowed
    if (!phoneRegex.test(phoneNumber)) {
      setPhoneNumberError("Phone number must be 10 digits long.");
      return false;
    }
    setPhoneNumberError("");
    return true;
  };
  const validateDate = (date) => {
    if (!date.trim()) {
      setDateError("Date is required.");
      return false;
    }
    setDateError("");
    return true;
  };
  const validateNatureOfComplaint = (natureOfComplaint) => {
    if (!natureOfComplaint.trim()) {
      setNatureOfComplaintError("Nature of complaint is required.");
      return false;
    }
    setNatureOfComplaintError("");
    return true;
  };
  const validateLocation = (location) => {
    if (!location.trim()) {
      setLocationError("Location is required.");
      return false;
    }
    setLocationError("");
    return true;
  };

  const validateBuildingNo = (buildingNo) => {
    if (!buildingNo.trim()) {
      setBuildingNoError("Qtr No./ Building No. is required.");
      return false;
    }
    setBuildingNoError("");
    return true;
  };
  const validateDescription = (description) => {
    if (!description.trim()) {
      setDescriptionError("Description is required.");
      return false;
    }
    setDescriptionError("");
    return true;
  };
  const validateUnit = (unit) => {
    if (!unit.trim()) {
      setUnitError("Unit is required.");
      return false;
    }
    setUnitError("");
    return true;
  };
  const validateComplaintType = (complaintType) => {
    if (!complaintType.trim()) {
      setComplaintTypeError("Nature of Complaint is required.");
      return false;
    }
    setComplaintTypeError("");
    return true;
  };
  const validateName = (name) => {
    if (!name.trim()) {
      setNameError("Name is required.");
      return false;
    }
    setNameError("");
    return true;
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setImages((prevImages) => [...prevImages, ...files]);
  };

  const handleUploadImages = () => {
    if (images && images.length > 0) {
      toast.loading("Uploading Images...");
      setLoading(true); // Set loading to true when the upload starts
      try {
        dispatch(
          postUploadImages({
            files: images,
          })
        ).then((response) => {
          setLoading(false); // Set loading to false after the API call
          if (response && response.status === 200) {
            // navigate("/super-admin/accounts");
            console.log("response", response);

            setImageUrls([
              ...imageUrls,
              response.data?.data?.map((item) => item.url),
            ]);
            toast.dismiss();
            toast.success("Images uploaded successfully!");
            setImageUploaded(true);
          } else {
            console.log("Image upload failed:", response);
            toast.dismiss();
          }
        });
      } catch (error) {
        setLoading(false); // Set loading to false if there's an error
        console.log("Image Uploading Error:", error);
        toast.dismiss();
      }
    } else {
      setLoading(false);
      toast.error("No images selected for upload.");
    }
  };
  const isImageUploaded = !imageUploaded && images?.length > 0;
  const handleSubmitData = () => {
    // const isSubjectValid = validateSubject(subject);
    const isDateValid = validateDate(date);
    const isLocationValid = validateLocation(location);
    const isUnitValid = validateUnit(unit);
    const isBuildingnoValid = validateBuildingNo(buildingNo);
    // const isNatureOfComplaintValid =
    //   validateNatureOfComplaint(natureOfComplaint);
    const isNameValid = validateName(name);
    const isComplaintTypeValid = validateComplaintType(complaintType);
    const isPhoneNumberValid = validatePhoneNumber(phoneNumber);

    if (
      // isSubjectValid &&
      isDateValid &&
      isLocationValid &&
      isUnitValid &&
      isBuildingnoValid &&
      // isNatureOfComplaintValid &&
      // isDescriptionValid &&
      isNameValid &&
      isComplaintTypeValid &&
      isPhoneNumberValid &&
      !isImageUploaded
      // &&
      // isImageUploaded
    ) {
      setLoading(true); // Set loading to true before making the API call
      try {
        dispatch(
          postRaiseComplaint({
            subject: subject,
            date: ConvertDateToEpoch(date),
            location: location,
            unit: unit,
            address: buildingNo,
            // complaint_nature: natureOfComplaint,
            description: description,
            complaint_type: complaintType,
            phone: phoneNumber,
            image: imageUrls[0],
            role: getCookie("role"),
            email: getCookie("email"),
            name: name,
          })
        ).then((response) => {
          setLoading(false); // Set loading to false after the API call
          if (response !== undefined) {
            navigate("/user/complaints");
            console.log("response complaint", response);
          }
        });
      } catch (error) {
        setLoading(false); // Set loading to false if there's an error
        console.log("Complaint raise error:", error);
      }
    } else {
      console.log("Validation errors");
    }
  };
  // Custom Next Arrow
  const NextArrow = ({ className, style, onClick }) => (
    <div
      className={`${className} custom-arrow`}
      style={{ ...style, display: "block", background: "blue", right: "10px" }}
      onClick={onClick}
    />
  );

  // Custom Prev Arrow
  const PrevArrow = ({ className, style, onClick }) => (
    <div
      className={`${className} custom-arrow`}
      style={{ ...style, display: "block", background: "blue", left: "10px" }}
      onClick={onClick}
    />
  );

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  function handleRemoveImage(indexOfImage) {
    // Create a new array without the image at the specified index
    const updatedImages = images.filter((_, index) => index !== indexOfImage);

    setImages(updatedImages);
  }

  return (
    <Card extra={"w-full h-full p-3"}>
      <div className="relative mb-3 flex items-center justify-between pt-1">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          Please fill out the following form.
        </h4>
      </div>

      <div className="grid grid-cols-2 gap-2 px-1">
        {/* Name */}
        <div className="mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Name of Indl<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              validateName(sanitizeInputManually(e.target.value));
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          {nameError && (
            <p className="mt-1.5 text-sm text-red-500">{nameError}</p>
          )}
        </div>
        {/* Subject */}
        <div className="mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Subject
          </label>
          <input
            type="text"
            value={subject}
            onChange={(e) => {
              setSubject(sanitizeInputManually(e.target.value));
              // validateSubject(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          {subjectError && (
            <p className="mt-1.5 text-sm text-red-500">{subjectError}</p>
          )}
        </div>

        {/* Date */}
        <div className="mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Date<span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
              validateDate(e.target.value);
            }}
            max={new Date().toISOString().split("T")[0]} // This sets the maximum date to today's date
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          {dateError && (
            <p className="mt-1.5 text-sm text-red-500">{dateError}</p>
          )}
        </div>

        {/* Location */}
        <div className="mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Location<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={location}
            onChange={(e) => {
              setLocation(sanitizeInputManually(e.target.value));
              validateLocation(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          {locationError && (
            <p className="mt-1.5 text-sm text-red-500">{locationError}</p>
          )}
        </div>

        {/* Unit */}
        <div className="mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Unit<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={unit}
            onChange={(e) => {
              setUnit(sanitizeInputManually(e.target.value));
              validateUnit(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          {unitError && (
            <p className="mt-1.5 text-sm text-red-500">{unitError}</p>
          )}
        </div>

        {/* Building No. */}
        <div className="mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Qtr. No. / Building No.<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={buildingNo}
            onChange={(e) => {
              setBuildingNo(sanitizeInputManually(e.target.value));
              validateBuildingNo(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          {buildingNoError && (
            <p className="mt-1.5 text-sm text-red-500">{buildingNoError}</p>
          )}
        </div>

        {/* Nature of Complaint */}
        {/* <div className="mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Nature of Complaint<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={natureOfComplaint}
            onChange={(e) => {
              setNatureOfComplaint(e.target.value);
              validateNatureOfComplaint(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          {natureOfComplaintError && (
            <p className="mt-1.5 text-sm text-red-500">
              {natureOfComplaintError}
            </p>
          )}
        </div> */}

        {/* Complaint Type */}
        <div className="mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Nature of Complaint<span className="text-red-500">*</span>
            {/* Complaint Type<span className="text-red-500">*</span> */}
          </label>
          <select
            id="complaintType"
            value={complaintType}
            onChange={(e) => {
              setComplaintType(e.target.value);
              validateComplaintType(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          >
            <option value="" className="text-gray-500">
              Select Nature of Complaint
            </option>
            <option value="B&R">B & R</option>
            <option value="E&M">E & M</option>
            <option value="Miscellaneous">Misc</option>
          </select>
          {complaintTypeError && (
            <p className="mt-1.5 text-sm text-red-500">{complaintTypeError}</p>
          )}
        </div>

        {/* Phone Number */}
        <div className="mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Phone Number<span className="text-red-500">*</span>
          </label>
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(sanitizeInputManually(e.target.value));
              validatePhoneNumber(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          {phoneNumberError && (
            <p className="mt-1.5 text-sm text-red-500">{phoneNumberError}</p>
          )}
        </div>

        <div className="col-span-2 grid w-full grid-cols-2 gap-2">
          <div className="">
            {/* Job Number */}
            <div className="mb-2">
              <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
                MES Job no.
              </label>
              <input
                type="text"
                value={jobNumber}
                disabled
                onChange={(e) => {
                  setjobNumber(sanitizeInputManually(e.target.value));
                  validateJobNumber(e.target.value);
                }}
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm disabled:cursor-not-allowed"
              />
              {jobNumberError && (
                <p className="mt-1.5 text-sm text-red-500">{jobNumberError}</p>
              )}
            </div>
            {/*Expected Date */}
            <div className="mb-2">
              <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
                Excpected Date to resolve
              </label>
              <input
                type="date"
                value={expectedDate}
                disabled
                onChange={(e) => {
                  setExpectedDate(e.target.value);
                  validateExpectedDate(e.target.value);
                }}
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm disabled:cursor-not-allowed"
              />
              {expectedDateError && (
                <p className="mt-1.5 text-sm text-red-500">
                  {expectedDateError}
                </p>
              )}
            </div>
          </div>
          {/* Description */}
          <div className="mb-2">
            <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
              Description
            </label>
            <textarea
              rows={5}
              value={description}
              onChange={(e) =>
                setDescription(sanitizeInputManually(e.target.value))
              }
              className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
            />
            {/* {descriptionError && (
                <p className="mt-1.5 text-sm text-red-500">
                  {descriptionError}
                </p>
              )} */}
          </div>
        </div>

        <div className="col-span-2 grid w-full grid-cols-2 gap-2">
          <div className="">
            {/* Complaint Status */}
            <div className="mb-2">
              <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white ">
                Complaint Status
              </label>
              <select
                id="complaintType"
                disabled
                value={complaintStatus}
                onChange={(e) => {
                  setComplaintStatus(e.target.value);
                  validateComplaintStatus(e.target.value);
                }}
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm disabled:cursor-not-allowed disabled:border-[#CBD5E0] disabled:bg-[#FAFAFA]"
              >
                <option value="" className="text-gray-500">
                  Select Complaint Status
                </option>
                <option value="0">Inactive</option>
                <option value="1">Closed</option>
                <option value="2">Active</option>
                <option value="3">Hold</option>
              </select>
              {complaintStatusError && (
                <p className="mt-1.5 text-sm text-red-500">
                  {complaintStatusError}
                </p>
              )}
            </div>
          </div>
          <div className="">
            {/* upload image button */}
            <div className="">
              <div className="mb-2 ">
                <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
                  Upload Images
                </label>
                <div className="relative block w-full rounded-lg border border-gray-300 p-1 text-sm">
                  {/* Hidden input element */}
                  <input
                    type="file"
                    accept=".jpeg, .jpg, .png"
                    multiple
                    onChange={handleFileChange}
                    className="hidden"
                    id="file-input"
                  />

                  {/* Custom button */}
                  <button
                    type="button"
                    onClick={() =>
                      document.getElementById("file-input").click()
                    }
                    className="rounded-md bg-blue-500 px-4 py-[7px] text-sm text-white"
                  >
                    + Add Image
                  </button>
                  <div className="absolute left-32 top-3">
                    {images.length} files
                  </div>
                  {imageUploaded && images?.length > 0 ? (
                    <div className="absolute left-56 top-2 text-green-600">
                      <BiCheckCircle size={25} />
                    </div>
                  ) : null}
                  <div
                    className={`absolute right-1 top-1 flex cursor-pointer items-center justify-center gap-2 rounded-md bg-brand-500 p-2 text-white active:bg-brand-600 ${
                      !images.length ? "cursor-not-allowed" : null
                    }`}
                    onClick={handleUploadImages}
                  >
                    <FiUpload />
                    <span>Upload</span>
                  </div>
                </div>
                {isImageUploaded && (
                  <p className="mt-1.5 text-sm text-red-500">
                    Please click the upload button to upload images
                  </p>
                )}
              </div>
            </div>
          </div>
          <div>
            {/* Comment */}
            {/* <div className="mb-2">
              <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
                Add Comments
              </label>
              <textarea
                rows={5}
                value={comment}
                disabled
                onChange={(e) => {
                  setComment(e.target.value);
                  validateComment(e.target.value);
                }}
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm disabled:cursor-not-allowed"
              />
              {commentError && (
                <p className="mt-1.5 text-sm text-red-500">{commentError}</p>
              )}
            </div> */}
          </div>
        </div>

        {/* image preview slider */}
        <div>
          {images.length > 1 ? (
            <div className="mb-4">
              <Slider {...sliderSettings}>
                {images.map((image, index) => (
                  <div key={index}>
                    <div className="w-100 relative flex h-64 justify-center rounded border bg-gray-500">
                      <div
                        className="absolute right-3 top-3 cursor-pointer rounded-full bg-white"
                        onClick={() => {
                          handleRemoveImage(index);
                        }}
                      >
                        <RxCrossCircled size={25} color="black" />
                      </div>
                      <img
                        src={URL.createObjectURL(image)}
                        alt={`Preview ${index}`}
                        className="h-auto w-auto rounded object-contain"
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          ) : images.length > 0 ? (
            <div>
              <div className="w-100 relative flex h-64 justify-center rounded border bg-gray-500">
                <div
                  className="absolute right-3 top-3 cursor-pointer rounded-full bg-white"
                  onClick={() => {
                    handleRemoveImage(0);
                  }}
                >
                  <RxCrossCircled size={25} color="black" />
                </div>
                <img
                  src={URL.createObjectURL(images[0])}
                  alt={`Preview`}
                  className="h-auto w-auto rounded object-contain"
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>

      {/* Submit Button */}
      <button
        onClick={handleSubmitData}
        disabled={submitting || loading}
        className={`linear mt-3 w-1/4 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white disabled:bg-gray-400 ${
          submitting || loading ? "cursor-not-allowed" : null
        }`}
      >
        {submitting || loading ? "Submitting..." : "Submit"}
      </button>
    </Card>
  );
};

export default RaiseComplaint;
